import * as React from 'react';
import Grid from '@material-ui/core/Grid';

import { paymentService } from 'services/PaymentService';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { cartService } from 'services/CartService';
import FieldText from 'components/Field/Text';
import { IS_ECOMMERCE } from 'settings';
import Fab from '@material-ui/core/Fab';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import Translate from 'components/Translate';

const style = require('./quantityForm.css');

interface IState extends IStateBase {
  quantity: number;
  limit: number;
  hideQuantity: boolean;
}

interface IProps {
  isPin?: boolean;
  isTicket?: boolean;
  hideLabel?: boolean;
}

export default class QuantityForm extends BaseComponent<IState, IProps> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {

    cartService.getCart()
      .combineLatest(paymentService.getCart())
      .bindComponent(this)
      .subscribe(([cart, paymentCart]) => {

        if (IS_ECOMMERCE) {
          return;
        }

        if (this.props.isPin) {
          this.setState({
            limit: cart.pins.purchaseLimit,
            hideQuantity: cart.pins.hideQuantity,
            quantity: paymentCart.quantity
          });
          return;
        }

        this.setState({
          limit: cart.config.purchaseLimit,
          hideQuantity: cart.config.hideQuantity,
          quantity: paymentCart.quantity
        });

      });
  }

  handleChange = (quantity: number) => {

    if (quantity == this.state.quantity) {
      return;
    }

    if (quantity > this.state.limit) {
      quantity = this.state.limit;
    }

    if (quantity <= 0) {
      quantity = 1;
    }

    paymentService.setData({ quantity: Number(quantity) });
  }

  decrement = () => {
    if (this.state.quantity <= 1) {
      paymentService.setData({ quantity: 1 });
      return;
    }

    paymentService.setData({ quantity: this.state.quantity - 1 });
  }

  increment = () => {
    if (this.state.quantity >= this.state.limit) {
      paymentService.setData({ quantity: this.state.limit });
      return;
    }

    paymentService.setData({ quantity: this.state.quantity + 1 });
  }

  render() {

    if (!this.state) {
      return null;
    }

    const { quantity, limit, hideQuantity } = this.state;

    return (
      <React.Fragment>
        <div className={style.component}>
          <Grid id='ticket_price_unique' className='item right' item xs={4}>
            {!hideQuantity &&
              <div className='quantity-content'>
                <div className='quantity-label theme-label'>
                  <Translate term='Quantidade' />
                </div>
                <div className='quantity-form theme-input'>
                  <Grid
                    className='quantity-form__ticket'
                    direction={'row'}
                    alignItems={'center'}
                    justify={'flex-start'}
                    wrap={'nowrap'}
                    container
                    xs={12}
                  >
                    <Fab className='fab__ticket' disabled={quantity === 1} onClick={this.decrement} size='small'>
                      <RemoveIcon />
                    </Fab>
                    <FieldText
                      id='quantity'
                      label={''}
                      validation={`required|numeric|min:1${limit > 0 ? `|max:${limit}` : ''}`}
                      disabled={true}
                      value={quantity}
                      inputProps={{
                        className: `quantityTicket quantity`,
                      }}
                      InputLabelProps={{
                        className: 'theme-label',
                        hidden: hideQuantity
                      }}
                      onChange={this.handleChange}
                    />
                    <Fab className='fab__ticket' disabled={quantity >= limit} onClick={this.increment} size='small'>
                      <AddIcon />
                    </Fab>
                  </Grid>
                </div>
              </div>
            }
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Physical/QuantityForm/index.tsx